/*!
 * @license
 * Copyright Squiz Australia Pty Ltd. All Rights Reserved.
 */

export const AI_THREAD_TABLE_CONSTANTS = {
  allRatings: 'All ratings',
  datetimePickerPlaceHolder: 'Select date and time',
  negative: 'Negative',
  positive: 'Positive',
  ratingFieldName: 'Rating',
};

export const AI_THREAD_TABLE_FILTER_DATA_IDS = {
  all: 'all',
  dateTime: 'dateTime',
  negative: 'negative',
  positive: 'positive',
  ratingSelect: 'rating-select',
  tags: 'tags',
  unrated: 'unrated',
};
